export const testimonials = [
  {
    name: 'Steven Tey',
    role: 'Founder, Dub',
    avatar: '/img/testimonials/steven.jpg',
    rating: 5,
    text: "This is the best software review/comparison site that I've ever seen.",
  },
  {
    name: 'Kevin Michaluk',
    role: 'Founder, Clicks',
    avatar: '/img/testimonials/kevin.jpg',
    rating: 5,
    text: 'The site is super thoughtful. Super, super thoughtful. Like, really really good!',
  },
  {
    name: 'Jordan Mancari',
    role: 'UX / Digital Manager',
    avatar: '/img/testimonials/jordan.jpg',
    rating: 5,
    text: "I so appreciate the time and detail you put into your reviews. It's noticed and makes a difference. Thanks for the generous work you are doing!",
  },
  {
    name: 'Laura Kaye',
    role: 'Founder, hownow',
    avatar: '/img/testimonials/laura.jpg',
    rating: 5,
    text: 'I just want to say I am such a huge fan of your channel. I found it a couple of months back, and now turn to it for all software review questions before anyone else at this point.',
  },
  {
    name: 'Andrew Kouri',
    role: 'Founder, Avery',
    avatar: '/img/testimonials/andrew.jpg',
    rating: 5,
    text: 'I always check the deals page now before purchasing software, thank you!',
  },
  {
    name: 'Cat Matson',
    role: 'CEO, Impactful Presenters',
    avatar: '/img/testimonials/cat.jpg',
    rating: 5,
    text: "Thank you! I love your detailed insights and you've saved me hours of researching and testing. You've also reminded me what I like about some tools, and what I dislike about others.",
  },
  {
    name: 'Clif Mathews',
    role: 'Partner, Deloitte',
    avatar: '/img/testimonials/clif.png',
    rating: 5,
    text: 'The combination of HIGH value content, with the perfect mix of authenticity and humor.',
  },
]

export const courseTestimonials = [
  {
    name: 'Alex Sinzer',
    rating: 5,
    text: 'Wow - I’m the CEO of a 200 person food manufacturing company. This video has been huge for us.',
  },
  {
    name: 'Ron Rgr',
    rating: 5,
    text: 'You easily convinced me to switch our team of 10 from Monday to Motion.',
  },
  {
    name: 'Vanessa Garcia',
    rating: 5,
    text: "I don't think I really ever knew what love was until I saw this video. To be clear, I'm talking about Motion. Thanks for the great vid!",
  },
  {
    name: 'Wynntom',
    rating: 5,
    text: 'Excellent breakdown, packed with insightful tips and tricks. Fantastic job.',
  },
  {
    name: 'Larson Studios',
    rating: 5,
    text: 'Love this video! Lots of on-the-nose help in a short amount of time!!',
  },
  {
    name: 'Jameson Kle',
    rating: 5,
    text: 'Super helpful tutorial - thank you!',
  },
  {
    name: 'Shashwat Gang',
    rating: 5,
    text: 'Really helpful, the best video on any software I ever saw.',
  },
  {
    name: 'Logical Pro',
    rating: 5,
    text: "Fantastic and educational! We've been weighing a bunch of solutions and your video is helping us go in the right direction. Thanks for putting it together!",
  },
]
